// La ficha de esta instalación (instalacion/instalacion.json) para las apps y el worker: nombre,
// direcciones y textos con marca. Se compila dentro del paquete; no se descarga en tiempo de uso.
import ficha from '../../../instalacion/instalacion.json' with { type: 'json' };

/** Una imagen de marca en sus dos temas: la app muestra la que corresponde al tema activo. */
interface ImagenDeMarca {
  claro: string;
  oscuro: string;
}

/**
 * Lo que una instalación puede agregar a la marca base. Sin estas claves la app pinta el nombre
 * como texto y no muestra autoría.
 */
interface MarcaOpcional {
  logo?: { horizontal: ImagenDeMarca; completo: ImagenDeMarca };
  autoria?: { antes: string; logo: ImagenDeMarca; alt: string; despues: string };
}

export const instalacion: typeof ficha & MarcaOpcional = ficha;
